// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserUserEditUser_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99957 6.99957C8.10407 6.99957 8.99945 6.1042 8.99945 4.99969C8.99945 3.89519 8.10407 2.99982 6.99957 2.99982C5.89507 2.99982 4.99969 3.89519 4.99969 4.99969C4.99969 6.1042 5.89507 6.99957 6.99957 6.99957ZM6.99957 8.99945C9.20858 8.99945 10.9993 7.2087 10.9993 4.99969C10.9993 2.79069 9.20858 0.999939 6.99957 0.999939C4.79057 0.999939 2.99982 2.79069 2.99982 4.99969C2.99982 7.2087 4.79057 8.99945 6.99957 8.99945ZM15.9988 8.90917L14.5801 7.49954L13.1846 8.90401L14.6033 10.3136L15.9988 8.90917ZM13.5321 11.3918L12.1133 9.98204L8.2371 13.8835L7.54397 15.9998L9.65576 15.2931L13.5321 11.3918ZM9.92902 10.762C9.06264 10.2763 8.06344 9.99939 6.99957 9.99939C3.6865 9.99939 1.00064 12.6848 0.999939 15.9977H2.99982C3.00052 13.7893 4.791 11.9993 6.99957 11.9993C7.50578 11.9993 7.99003 12.0933 8.43579 12.2649L9.92902 10.762Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10C14.2091 10 16 8.20914 16 6 16 3.79086 14.2091 2 12 2 9.79086 2 8 3.79086 8 6 8 8.20914 9.79086 10 12 10ZM12 12C15.3137 12 18 9.31371 18 6 18 2.68629 15.3137 0 12 0 8.68629 0 6 2.68629 6 6 6 9.31371 8.68629 12 12 12ZM12.6863 20.8196 11.5 24 14.8076 22.9452 21.8787 15.8597 19.7574 13.7341 12.6863 20.8196ZM20.4645 13.0255 21.8787 11.6084 24 13.7341 22.5858 15.1512 20.4645 13.0255Z" class="svg-bg"/>
  <path d="M14.3275 16.3439C13.591 16.1203 12.8096 16 12 16C7.58172 16 4 19.5817 4 24H2C2 18.4772 6.47715 14 12 14C13.378 14 14.6909 14.2787 15.8854 14.7829L14.3275 16.3439Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserUserEditUser is a generated icon component.
 */
let IconUserUserEditUser = IconUserUserEditUser_1 = class IconUserUserEditUser extends IconBaseElement {
    render() {
        return html `${IconUserUserEditUser_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserUserEditUser.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserUserEditUser = IconUserUserEditUser_1 = __decorate([
    customElement('zui-icon-user-user-edit-user')
], IconUserUserEditUser);
export { IconUserUserEditUser };
